<!--
 * @Description: 员工离职交接
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-21 15:24:25
-->
<template>
  <div>
    <!-- :hideAddBtn="!hasBtn('add-staff-handover')"  pageName="addStaffConnect"-->
    <mrc_ess_table v-if="$route.name == 'staffConnect'" :headers="headers" :hideAddBtn="true" :paginationOptions="options"
      @turnPage="getlist" :isLoading="loading" :slotKey="['name', 'handoverName', 'handover_date', 'result_status']"
      :items="desserts">
      <template v-slot:search>
        <v-row class="d-flex justify-end" style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4" v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })" :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <mrc_ess_staffListView :staffuuid="item.apply_staff_uuid" :allList="allList">
        </mrc_ess_staffListView>
      </template>

      <template v-slot:item.handoverName="{ item }">
        <mrc_ess_staffListView :staffuuid="item.handover_staff_uuid" :allList="allList">
        </mrc_ess_staffListView>
      </template>

      <template v-slot:item.handover_date="{ item }">
        {{ item.handover_date | changeDate() }}
      </template>

      <template v-slot:item.result_status="{ item }">
        <v-chip rounded color="grey" small class="white--text" v-if="item.result_status == 0">{{ $t("label_Unchanged")
        }}</v-chip>
        <v-chip rounded color="#18A874" small class="white--text" v-if="item.result_status == 1">{{ $t("label_Complete")
        }}</v-chip>
        <v-chip rounded color="#18A874" small class="white--text" v-if="item.result_status == 2">{{
          $t("label_The_task_processing_is_complete") }}
        </v-chip>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="[
          {
            name: $t('label_View'),
            show: hasBtn('view-staff-handover'),
            type: 'view',
          },
          {
            name: $t('label_Edit'),
            show: hasBtn('edit-staff-handover') && item.result_status == 0,
            type: 'edit',
          },
          {
            name: $t('label_delete'),
            show: hasBtn('delete-staff-handover') && item.result_status == 0,
            type: 'del',
          },
        ]" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
              'view-staff-handover',
              'edit-staff-handover',
              'delete-staff-handover',
            ]">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { getStaffListForFilter } from "@/service/api/autoComplete.js"
import {
  getHandoverList,
  addHandover,
  updateHandover,
  deleteHandover,
  detailHandover,
} from "@/service/api/staffmsg.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      stepIndex: 1,
      dialog: false,
      list: {},
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      allList: [],
      loading: false,
      desserts: [],
    }
  },
  computed: {
    stepList() {
      return [
        {
          name: this.$t("label_Importing_files"),
        },
        {
          name: this.$t("label_result"),
        },
      ]
    },
    // menulist () {
    //   return [
    //     {
    //       name: this.$t('label_View'),
    //       show: this.hasBtn('view-staff-handover'),
    //       type: 'view',
    //     },
    //     {
    //       name: this.$t('label_Edit'),
    //       show: this.hasBtn('edit-staff-handover'),
    //       type: 'edit',
    //     },
    //     {
    //       name: this.$t('label_delete'),
    //       show: this.hasBtn('delete-staff-handover'),
    //       type: 'del',
    //     },
    //   ]
    // },
    headers() {
      return [
        {
          text: this.$t("label_A_departing_employee"),
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("label_Handover_time"),
          value: "handover_date",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_Hand_over_personnel"),
          value: "handoverName",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_The_execution_status"),
          value: "result_status",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "staffConnect") {
        this.getlist()
      }
    },
  },
  async mounted() {
    this.loading = true
    await this.getdropDownList()

    await this.getlist()
    this.loading = false
  },
  beforeDestroy() {
    this.$ls.remove("staffList")
  },
  methods: {
    async getdropDownList() {
      const res = await getStaffListForFilter({
        org_level_uuid: this.$store.state.currentCompany,
      })
      if (res.code == 200) {
        this.allList = res.data
      }
    },
    changeIndex(v) {
      if (v == 0) {
        this.dialog = false
      } else if (v == 3) {
        //提交代码逻辑
      } else {
        this.stepIndex = v
      }
    },
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getHandoverList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    addStaffLeave() {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addStaffConnect",
      })
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_listObj", item) //保存这条数据
      // this.$store.commit('set_subPage_name', item.job_name)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailStaffConnect",
      })
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          // this.$store.commit('set_subPage_name', obj.job_name)
          this.$store.commit("set_listObj", obj) //保存这条数据
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailStaffConnect",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteHandover({ uuid: obj.uuid }).then((res) => {
              if (res.code === "200") {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
    success() { },
    cancel() { },
  },
}
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
